import React from 'react';
import { SharedEventList } from '@/app/events/shared-event-list';

// Import styles
import './styles/toutix-whitelabel.css';

interface EventListPageContainerProps {
  className?: string;
}

export const EventListPageContainer: React.FC<EventListPageContainerProps> = ({ 
  className = '' 
}) => {
  return (
    <div className={`toutix-whitelabel ${className}`}>
      <SharedEventList />
    </div>
  );
};
